import axios from 'axios';
import wix from './wix';
import { LCF_POST_FORM_URL } from '../constants/endpoints';

class LeadCaptureFormServerApi {
  _fetch(options) {
    options.headers = {
      ...options.headers,
      'X-Wix-Chat-Instance': wix.getInstance(),
      Authorization: wix.getInstance(),
    };
    return axios(options).then((response) => response.data);
  }

  postForm(fields) {
    return this._fetch({
      method: 'post',
      url: LCF_POST_FORM_URL,
      data: { fields },
    });
  }
}

export default new LeadCaptureFormServerApi();
